import {Injectable} from '@angular/core';
import {EntryFormattingPort} from "../../../../../shared/domain/ports/entry-formatting.port";
import {Entry} from "../../domain/model/entry.model";
import {EntryMapper} from "../mapper/entry.mapper";
import {IApiEntry} from "../../../../../shared/infrastructure/dto/entry-api.interface";


@Injectable({providedIn: 'root'})
export class EntryFormattingService implements EntryFormattingPort {
  toReleaseDto(entry: Entry): IApiEntry {
    return EntryMapper.toApi(entry);
  }

  toReleaseDtoList(entries: Entry[]): IApiEntry[] {
    return entries.map(entry => this.toReleaseDto(entry));
  }

  fromDtoToModel(entry: IApiEntry): Entry {
    return EntryMapper.toModel(EntryMapper.toStorageFromApi(entry));
  }

  fromDtoToModelList(entries: IApiEntry[]): Entry[] {
    return entries.map(entry => this.fromDtoToModel(entry));
  }
}
